'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var Pagination = function (_Component) {
    (0, _inherits3.default)(Pagination, _Component);

    function Pagination() {
        (0, _classCallCheck3.default)(this, Pagination);
        return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).apply(this, arguments));
    }

    (0, _createClass3.default)(Pagination, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                hasPreviousPage = _props.hasPreviousPage,
                hasNextPage = _props.hasNextPage,
                onPreviousPageClick = _props.onPreviousPageClick,
                onNextPageClick = _props.onNextPageClick,
                currentlyShown = _props.currentlyShown,
                total = _props.total;

            var pagerButtonClasses = ['material-icons', 'waves-effect'];

            var previousPageClasses = (0, _classnames2.default)(pagerButtonClasses, { 'data-table-pager--previous-page__disabled': !hasPreviousPage() });
            var nextPageClasses = (0, _classnames2.default)(pagerButtonClasses, { 'data-table-pager--next-page__disabled': !hasNextPage() });

            return _react2.default.createElement(
                'div',
                { className: 'data-table-pager' },
                _react2.default.createElement(
                    'ul',
                    { className: 'data-table-pager--buttons' },
                    total ? _react2.default.createElement(
                        'li',
                        { className: 'data-table-pager--page-info' },
                        _react2.default.createElement(
                            'span',
                            null,
                            currentlyShown,
                            ' / ',
                            total
                        )
                    ) : '',
                    _react2.default.createElement(
                        'li',
                        { className: 'data-table-pager--previous-page' },
                        _react2.default.createElement(
                            'i',
                            {
                                className: previousPageClasses,
                                onClick: hasPreviousPage() ? onPreviousPageClick : noop
                            },
                            'navigate_before'
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'data-table-pager--next-page' },
                        _react2.default.createElement(
                            'i',
                            {
                                className: nextPageClasses,
                                onClick: hasNextPage() ? onNextPageClick : noop
                            },
                            'navigate_next'
                        )
                    )
                )
            );
        }
    }]);
    return Pagination;
}(_react.Component);

Pagination.propTypes = {
    hasPreviousPage: _propTypes2.default.func,
    hasNextPage: _propTypes2.default.func,
    onPreviousPageClick: _propTypes2.default.func,
    onNextPageClick: _propTypes2.default.func,
    total: _propTypes2.default.number,
    currentlyShown: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Pagination.defaultProps = {
    hasPreviousPage: noop,
    hasNextPage: noop,
    onPreviousPageClick: noop,
    onNextPageClick: noop,
    total: 0,
    currentlyShown: 0
};

exports.default = Pagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-core/pagination/Pagination.component.js
// module id = 1907
// module chunks = 0